import React, { Component } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField/index';
import {insertSubmit} from '../../../../../../services/InsertSubmit'
import Typography from '@material-ui/core/Typography';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';
import {deleteSubmit} from  '../../../../../../services/deleteSubmit'
moment.locale('es')

class WindowModalDelete extends Component {

    
    constructor(props) {
        super(props);
        var requiredOut=false
        var requiredError=false
        if(props.row.fuera===0){
            requiredOut=true
        }
        if(props.row.error===0){
            requiredError=true
        }
        sessionStorage.setItem("data", JSON.stringify(this.props.row))
        this.state = {
            dataObjective:this.props.dataObjective,
            day:this.props.row.dia,
            perf:this.props.row.perf,
            error:this.props.row.error,
            out:this.props.row.fuera,
            sample:this.props.row.muestra,
            data:this.props.row,
            errorValue:false,
            average:this.props.row.tiempo,
            msg:["Valores Ingresados deben tener como Resultado 100%"], 
            indexmsg:0,
            fieldChange:'',
            OutRequired:requiredOut,
            ErrorRequired:requiredError,
            sampleRequired:false,
            openPop:false,
            anchorPop:null
        }
    }

   

    delete=()=>{       
        
        const {day,error, perf, sample,average, dataObjective}=this.state
        deleteSubmit(dataObjective.objetivo_id, dataObjective.paso, day, error, sample, perf, average).then( data => {
            this.props.handleCloseControl()
            this.setState({
                errorValue:false
            });
        })
        this.props.handleControl(day)
        this.close()
        
    }

    close=()=>{
        this.props.handleCloseControl()
    }
  
    handlePopover=(event)=>{
        this.setState(prevState => ({
            openPop: !prevState.openPop,
            anchorPop:event.currentTarget
        }));
        
    }
    

    render() {
        const {classes}= this.props
        const {day} =this.state
        return(
        <Grid
            container
            spacing={1}
            style={{backgroundColor:"white", width:"35%"}}
        >
          
            <Grid
                item
                xs={2}
                sm={2}
                md={2}
                xl={2}
                style={{textAlign:"right"}}
            >
                <Button onClick={this.close}><CloseIcon/></Button>
            </Grid>           
           
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <Typography>¿ esta seguro de restablecer valor para el dia {day} ?</Typography>
            </Grid>
            
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
            >
                <Button onClick={this.delete} className={classes.button}>Aceptar</Button>
            </Grid>
        </Grid>
    )
        
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(WindowModalDelete);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlObjective/WindowModalDelete/index.jsx